<template>
  <div class="expansion-panel-content-container">
    <div class="title-container">
      <font-awesome-icon
        :icon="['fa', 'ship']"
        style="font-size: 1.2rem"
        color="var(--color-text)"
      />
      <span class="panel-title">Departure settings </span>
    </div>
    <div style="height: 20px"></div>
    <div class="date-time-container">
      <v-dialog
        ref="dateDialog"
        v-model="modal"
        persistent
        width="290px"
        :return-value.sync="dateModel"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="dateModel"
            label="Start date"
            append-icon="mdi-calendar"
            color="var(--color-text)"
            outlined
            readonly
            persistent-placeholder
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-date-picker dar v-model="dateModel" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dateDialog.save(dateModel)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
        ref="timeDialog"
        v-model="modal2"
        :return-value.sync="timeModel"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <ThemedTextField
            v-model="timeModel"
            label="Start time"
            append-icon="mdi-clock-time-four-outline"
            outlined
            readonly
            v-bind="attrs"
            v-on="on"
          />
        </template>
        <v-time-picker v-if="modal2" v-model="timeModel" full-width>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal2 = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.timeDialog.save(timeModel)">
            OK
          </v-btn>
        </v-time-picker>
      </v-dialog>
    </div>
    <div class="etd-window-container">
      <ThemedTextField
        label="ETD Window"
        outlined
        type="number"
        persistent-placeholder
        v-model="etdWindowModel"
      />
    </div>
  </div>
</template>
  
  <script>
import { mapState } from "vuex";
import ThemedTextField from "@/core/ThemedTextField.vue";
export default {
  name: "PickDateTimeComponent",
  components: {
    ThemedTextField,
  },
  data: function () {
    return {
      openedPanel: [],
      modal: false,
      modal2: false,
    };
  },
  computed: {
    ...mapState("weatherRouting/formModule", [
      "voyageDate",
      "voyageTime",
      "etdWindow",
    ]),
    dateModel: {
      get() {
        return this.voyageDate;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_DATE",
          value,
          { root: true }
        );
      },
    },
    timeModel: {
      get() {
        return this.voyageTime;
      },
      set(value) {
        this.$store.commit(
          "weatherRouting/formModule/SET_SELECTED_TIME",
          value,
          { root: true }
        );
      },
    },
    etdWindowModel: {
      get() {
        return this.etdWindow;
      },
      set(value) {
        this.$store.commit("weatherRouting/formModule/SET_ETD_WINDOW", value, {
          root: true,
        });
      },
    },
    isPanelOpen() {
      return this.openedPanel.length != 0;
    },
  },
};
</script>
  
<style scoped>
.panel-title {
  color: var(--color-text);
}

.title-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.expansion-panel-content-container {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.date-time-container {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.etd-window-container {
  width: 50%;
}
</style>